module.exports = __webpack_public_path__ + "resources/fonts/logo_bydehand-068dcff352d9f490d970c527f21e33a7-cache.svg";